import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import Header from './components/Header11';
import Footer from './components/Footer11';

const FAQs11 = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const faqs = [
        { question: 'How do I find my correct size?', answer: 'We recommend referring to our detailed size chart available on each product page. You can also visit our studio for in-person measurements, or contact our styling team for virtual fitting assistance.' },
        { question: 'What is your return policy?', answer: 'We offer a 15-day easy return policy on all products. Items must be unworn, unwashed, and in their original packaging with tags attached. Custom-tailored pieces are non-returnable.' },
        { question: 'Do you offer custom tailoring?', answer: 'Yes, we offer bespoke tailoring for sherwanis, suits, and bandhgalas. Visit our studio or book a virtual consultation. Custom orders typically take 3-4 weeks.' },
        { question: 'How long does shipping take?', answer: 'Standard shipping takes 5-7 business days across India. Express shipping (2-3 business days) is available for an additional charge. We ship pan-India and to select international destinations.' },
        { question: 'What payment methods do you accept?', answer: 'We accept all major credit and debit cards, UPI, net banking, and Cash on Delivery (for orders under \u20B950,000). EMI options are available on select banks.' },
        { question: 'How do I care for my garments?', answer: 'Most of our premium garments are dry-clean only. Detailed care instructions are provided with each purchase. Store sherwanis and suits on broad-shouldered hangers in garment bags.' },
        { question: 'Can I modify or cancel my order?', answer: 'Orders can be modified or cancelled within 12 hours of placement. Once the order is in processing or shipped, modifications are not possible. Contact our support team immediately for any changes.' },
        { question: 'Do you offer styling consultations?', answer: 'Yes! Our expert stylists offer free consultations for wedding outfits and bulk purchases. Book a session through our Contact page or call us directly.' },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=Source+Sans+3:wght@300;400;600&display=swap');
            `}</style>

            <div style={{ fontFamily: "'Source Sans 3', -apple-system, sans-serif" }} className="min-h-screen bg-[#1C1917]">
                <Header />

                <main className="pt-[100px] pb-16 px-4 sm:px-6">
                    <div className="max-w-[800px] mx-auto">
                        <div className="text-center mb-12">
                            <div className="w-10 h-0.5 mx-auto mb-4" style={{ backgroundColor: '#D97706' }} />
                            <p className="text-xs tracking-[0.3em] uppercase mb-3" style={{ color: '#D97706', fontFamily: "'Oswald', sans-serif", fontWeight: 500 }}>Help Center</p>
                            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase', letterSpacing: '2px' }}>
                                FREQUENTLY ASKED QUESTIONS
                            </h1>
                        </div>

                        <div className="space-y-0">
                            {faqs.map((faq, i) => (
                                <div key={i} style={{ borderBottom: '1px solid #44403C' }}>
                                    <button
                                        onClick={() => setOpenIndex(openIndex === i ? null : i)}
                                        className="w-full flex justify-between items-center py-5 text-left"
                                        style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                                    >
                                        <span className="text-sm sm:text-base font-semibold pr-4" style={{ fontFamily: "'Source Sans 3', sans-serif", color: openIndex === i ? '#D97706' : '#FAFAF9' }}>
                                            {faq.question}
                                        </span>
                                        {openIndex === i
                                            ? <ChevronUp size={20} style={{ color: '#D97706', flexShrink: 0 }} />
                                            : <ChevronDown size={20} style={{ color: '#A8A29E', flexShrink: 0 }} />
                                        }
                                    </button>
                                    {openIndex === i && (
                                        <div className="pb-5">
                                            <p className="text-sm leading-relaxed" style={{ color: '#A8A29E' }}>{faq.answer}</p>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        <div className="mt-12 p-6 text-center" style={{ backgroundColor: '#292524', border: '1px solid #44403C' }}>
                            <p className="text-sm mb-4" style={{ color: '#A8A29E' }}>Still have questions?</p>
                            <button
                                onClick={() => window.location.href = '/template11/contact'}
                                className="px-8 py-3 text-sm tracking-[0.15em] uppercase"
                                style={{ backgroundColor: '#D97706', border: 'none', color: '#1C1917', fontFamily: "'Oswald', sans-serif", fontWeight: 600, cursor: 'pointer' }}
                            >
                                Contact Us
                            </button>
                        </div>
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default FAQs11;
